//Polyfill old browsers.
// import "babel-polyfill";
// import "whatwg-fetch";

import { Redirect } from "react-router";
import { Route, HashRouter } from "react-router-dom";

import React from "react";
import { render } from "react-dom";

import { FullPageFrame } from "./app/frame/FullPageFrame.jsx";
import { AppFrame } from "./app/frame/AppFrame.jsx";

import { isSessionValid } from "./app/store/auth/AuthFilters";
import { logout } from "./app/store/auth/AuthActions.js";
import { Provider } from "react-redux"
import store from "./app/store";

import "./app/store/websocket/index.js";

// TODO : Move this to be handled by a different npm script
// import "sass/app.scss";
// import "react-notifications/lib/notifications.css";


import { NotificationContainer } from "react-notifications";

/// Adapted from: <https://jasonwatmore.com/post/2020/03/23/react-router-remove-trailing-slash-from-urls>
const StripTrailingSlash = () =>  <Route path="/:url*(/+)" render={props => (<Redirect push={false} to={"/" + props.match.params.url} />)} />;

render(
    <HashRouter>
        <Provider store={store} >
            <div>
                <StripTrailingSlash />
                <Route exact path="/logout" render={() => {
                    store.dispatch(logout());
                    return <Redirect to="/" />
                } } />
                <Route path="/" render={(rest) => (rest.location.pathname == "/help" || rest.location.pathname == "/privacy" || isSessionValid() ? <AppFrame {...rest} /> : <FullPageFrame {...rest} />)} />
                <NotificationContainer />
            </div> 
        </Provider>
    </HashRouter >, document.querySelector("#app")
)